"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Navbar_container_1 = __importDefault(require("./Navbar.container"));
exports.default = Navbar_container_1.default;
//# sourceMappingURL=index.js.map